import LoginPage from 'Pages/Login';
import React from 'react';
import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router';
import Layout from './Layout';

// The router lives outside the React tree so sagas and boot code can call
// router.navigate directly — no hand-rolled history object involved.
export const router = createBrowserRouter(createRoutesFromElements(
    <>
        <Route element={<LoginPage/>} path="/login"/>
        <Route element={<Layout/>} path="/*"/>
    </>
));
